import { computed, onScopeDispose, ref, watch } from "vue";

// status API が応答も reject もしない場合でもボトムバーの主要操作を塞がないための猶予。
export const BOTTOM_BAR_STATUS_SETTLE_TIMEOUT_MS = 5000;

// リスクアセスメント / ハイリスク報告の Launcher の初回ステータス確定を集約する。
// 確定前はボトムバーを隠し、後から増えるボタンで中央のボタンが横にずれるのを防ぐ。
export function useBottomBarStatusSettled() {
  const riskAssessmentSettled = ref(false);
  const highRiskReportSettled = ref(false);
  const timedOut = ref(false);
  const allSettled = computed(() => riskAssessmentSettled.value && highRiskReportSettled.value);

  let timer: ReturnType<typeof setTimeout> | null = null;
  const clearTimer = (): void => {
    if (timer === null) return;
    clearTimeout(timer);
    timer = null;
  };

  // 未確定になるたびに猶予を数え直し、超過したら確定扱いにする（fail-open）。
  watch(
    allSettled,
    (settled) => {
      clearTimer();
      timedOut.value = false;
      if (settled) return;
      timer = setTimeout(() => {
        timer = null;
        timedOut.value = true;
      }, BOTTOM_BAR_STATUS_SETTLE_TIMEOUT_MS);
    },
    { immediate: true, flush: "sync" }
  );
  onScopeDispose(clearTimer);

  const isBottomBarStatusSettled = computed(() => allSettled.value || timedOut.value);

  return { riskAssessmentSettled, highRiskReportSettled, isBottomBarStatusSettled };
}
